<template>
  <Popup show="{{value}}" position="bottom" bindclose="onClose">
    <view class="title">
      <text>{{title}}</text>
      <view bindtap="onClose" class="close-icon"></view>
    </view>
    <view wx:if="{{fuzzy}}" class="tab-container">
      <Tab
        tabList="{{tabList}}"
        tabKey="{{dateType}}"
        bind:settabkey="setTabkey"
      />
    </view>
    <Calendar
      class="tab-content"
      wx:class="{{ {visible:dateType === 'exact' } }}"
      type="{{type}}"
      title="{{''}}"
      value="{{calendarDate}}"
      bindconfirm="onConfirm"
      minDate="{{minDate}}"
      maxDate="{{maxDate}}"
      maxRange="{{maxRange}}"
      bizType="{{bizType}}"
      subTexts="{{subTexts}}"
    />
    <FuzzySelectDate
      class="tab-content"
      wx:class="{{ {visible:dateType === 'fuzzy' } }}"
      fuzzyDate="{{fuzzyDate}}"
      bindconfirm="onFuzzyConfirm"
    />
  </Popup>
</template>
<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    properties: {
      value: {
        type: Boolean,
        value: false
      },
      bizType: {
        type: String,
        value: 'train', // flights
      },
      type: {
        type: String,
        value: 'single'
      },
      title: {
        type: String,
        value: '选择日期'
      },
      selectDate: {
        type: Array,
        value: () => ([])
      },
      subTexts: {
        type: Array,
        value: () => ([])
      },
      fuzzy: { // 是否支持模糊查询
        type: Boolean,
        value: false
      },
      fuzzyDate: {
        type: Object,
        value: null
      },
      minDate: {
        type: Number,
        optionalTypes: [String],
        value: Date.now()
      },
      maxDate: {
        type: Number,
        optionalTypes: [String],
        value: Date.now()
      },
      maxRange: {
        type: Number,
        value: 366
      }
    },
    data: {
      calendarDate: [],
      tabList: [{
        label: '精准日期',
        value: 'exact',
      }, {
        label: '模糊日期',
        value: 'fuzzy',
      }],
      dateType: 'fuzzy',
    },
    watch: {
      value: { // 避免在Popup关闭时由于props数据变动导致卡顿
        handler(next, prev) {
          if(next && !prev) {
            this.calendarDate = this.type === 'single'
              ? [this.selectDate[0]]
              : this.selectDate
          }
          const dateType = (this.fuzzy && this.fuzzyDate)
            ? 'fuzzy'
            : 'exact'
          this.setTabkey({
            detail: dateType
          })
        },
        immediate: true
      }
    },
    methods: {
      onClose() {
        this.triggerEvent('input', {
          value: false
        })
      },
      onConfirm({ detail }) {
        this.onClose()
        if(this.type === 'single') {
          this.triggerEvent('confirm', {
            single: detail[0]
          })
        }else if(this.type === 'range') {
          this.calendarDate = [...detail]
          this.triggerEvent('confirm', {
            range: detail.slice()
          })
        }
      },
      onFuzzyConfirm({ detail }) {
        this.onClose()
        this.triggerEvent('confirm', {
          fuzzy: detail
        })
      },
      setTabkey({ detail }) {
        this.dateType = detail
      },
    }
  })
</script>

<script name='json'>
  module.exports = {
    usingComponents: {
      'Popup': '@didi/spring-ui/ts-popup',
      'Calendar': '@didi/spring-ui/calendar',
      'Tab': '@didi/spring-ui/tab',
      'FuzzySelectDate': './fuzzy-select-date.mpx',
    }
  }
</script>

<style lang="stylus" scoped>
.tab-container
  overflow hidden
  background-color #fff
.tab-content
  position absolute
  visibility hidden
  z-index -1
  &.visible
    position static
    visibility visible
.title
  display flex
  align-items center
  justify-content center
  height 60px
  position relative
  color #000
  font-family PingFang SC
  font-weight 500
  font-size 18px
  background-color #fff
  border-radius 16px 16px 0 0
  .close-icon
    width 50px
    height 50px
    position absolute
    top 3px
    right 0
    background-size 24px 24px
    background-position center
    background-image url('https://ut-static.udache.com/webx/sfc/EQbJIaPUtU4WMcMPFzTPU_clipboard_image_1701312649516.png')
    background-repeat no-repeat
</style>